import { Form } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { IFieldUser } from '../../components/fieldUser';
import useEffectBuffer from '../../hooks/useEffectBuffer';
import { ItemType, UserSelect } from '../../index';
import { RootState } from '../../store';
import { MappingItemIdIndexType } from '../../types';

export const GantFieldTeam = <T extends Record<string, any>>({ disabled, name, label, mode }: IFieldUser<T>) => {
    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);

    const [selectedValue, setSelectedValue] = useState<string[]>();

    useEffectBuffer(
        () => {
            const hasItemChildren = currentGantItem?.children && currentGantItem.children.length > 0;

            if (!currentGantItem || !hasItemChildren) {
                return;
            }

            const collectChildAssignees = (item: ItemType, assigneeSet: Set<string>) => {
                if (!item.children || !item.children.length) {
                    return;
                }

                item.children.forEach((child) => {
                    const childItem = itemsList[mappingItemIdIndex[child]];
                    if (childItem) {
                        if (childItem.assignee) {
                            childItem.assignee.forEach((assignee) => assigneeSet.add(assignee));
                        }
                        collectChildAssignees(childItem, assigneeSet);
                    }
                });
            };

            const uniqueAssignee = new Set<string>();
            collectChildAssignees(currentGantItem, uniqueAssignee);
            setSelectedValue(Array.from(uniqueAssignee));
        },
        100,
        [itemsList, mappingItemIdIndex, currentGantItem],
    );

    return (
        <Form.Item<T> label={label} name={name as any}>
            <UserSelect
                disabled={disabled}
                mode={mode}
                selectedValue={selectedValue}
                onlyForProject={currentGantItem?.projectId ? [currentGantItem?.projectId] : []}
            />
        </Form.Item>
    );
};
